module.exports = __webpack_public_path__ + "img/velocity.86cbafa9.png";